import { call, put, takeEvery } from 'redux-saga/effects';
import { searchByCounties } from '../../requests/search_by_counties_request';
import { searchLeadCountyRequestSuccess, searchLeadCountyRequestFailure } from '../actions/search_lead_county.actions';
import { SEARCH_LEAD_COUNTY_REQUEST } from '../constants/search_lead_county.constants';
import { message_error } from '../../../../../components/Message';

function* searchLeadCountyRequest({ searchText }) {
    const { result, options, error } = yield call(searchByCounties, searchText);

    if (result) {
        yield put(searchLeadCountyRequestSuccess(options));
    } else {
        yield put(searchLeadCountyRequestFailure(error));
        message_error(error);
    }
}

export default function* searchLeadCountySaga() {
    yield takeEvery(SEARCH_LEAD_COUNTY_REQUEST, searchLeadCountyRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/search_lead_county.saga.js